import * as React from 'react';
import type { SVGProps } from 'react';
const SvgUserCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M18.5 12a6.5 6.5 0 0 1-6.5 6.5V20a8 8 0 0 0 8-8zM12 18.5A6.5 6.5 0 0 1 5.5 12H4a8 8 0 0 0 8 8zM5.5 12A6.5 6.5 0 0 1 12 5.5V4a8 8 0 0 0-8 8zM12 5.5a6.5 6.5 0 0 1 6.5 6.5H20a8 8 0 0 0-8-8z"
    />
    <path
      fill="currentColor"
      d="M13.5 10a1.5 1.5 0 0 1-1.5 1.5V13a3 3 0 0 0 3-3zM12 11.5a1.5 1.5 0 0 1-1.5-1.5H9a3 3 0 0 0 3 3zM10.5 10A1.5 1.5 0 0 1 12 8.5V7a3 3 0 0 0-3 3zM12 8.5a1.5 1.5 0 0 1 1.5 1.5H15a3 3 0 0 0-3-3zM6.621 16.52a.75.75 0 1 0 1.153.96zm9.606.96a.75.75 0 1 0 1.152-.96zm-8.453 0A5.49 5.49 0 0 1 12 15.5V14a6.99 6.99 0 0 0-5.379 2.52zM12 15.5c1.698 0 3.217.769 4.227 1.98l1.152-.96A6.99 6.99 0 0 0 12 14z"
    />
  </svg>
);
export default SvgUserCircle;
